import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { CollapsibleSection } from "./CollapsibleSection"
import { FieldsGrid } from "./FieldsGrid"

/**
 * Keys the backend keeps in `additional_attributes` for its own bookkeeping, not
 * customer data. `enriched_from_declaration_date` is the supplier-enrichment
 * provenance date (mc_declaration_review_service): it stops an older
 * declaration from overwriting newer supplier data, so it must stay stored, but
 * it is not a value anyone imported or entered. Both spellings, since the API
 * may return the key camelCased.
 */
const INTERNAL_ATTRIBUTE_KEYS = new Set([
  "enriched_from_declaration_date",
  "enrichedFromDeclarationDate",
])

interface AdditionalAttributesProps {
  attributes: Record<string, unknown>
}

export function AdditionalAttributes({
  attributes,
}: AdditionalAttributesProps) {
  const { translate } = useTranslation()
  const entries = Object.entries(attributes).filter(
    ([k]) => !INTERNAL_ATTRIBUTE_KEYS.has(k),
  )
  if (entries.length === 0) return null

  return (
    <CollapsibleSection
      label={translate("MC_MD_ATTRS_SECTION")}
      badge={<span className="text-xs text-grey5">{entries.length}</span>}
    >
      <FieldsGrid
        fields={entries.map(([k, v]) => ({
          label: k,
          value: String(v ?? "—"),
        }))}
      />
      <p className="px-4 pb-4 pt-2 text-xs text-grey5">
        {translate("MC_MD_ATTRS_FOOTNOTE")}
      </p>
    </CollapsibleSection>
  )
}
